import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { _UpdateStandardImp } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { ProductionOrderEditor } from "../ProductionOrderEditor";
import { FileInput } from "../../../theme/Component/FileInput";



export const TaskSpecial = () => {

    const masive = useDataBean(_UpdateStandardImp);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalmasivo, setModalmasivo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalstandar, setModalstandar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmateria, setModalmateria] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [saldocostos, setSaldocostos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [saldoproducto, setSaldoproducto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [saldoproductotermiando, setSaldoproductoterminado] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    const veractualizarmasivo = () => {

        setModalmasivo({ ...modalmasivo, "view": true });

    }
    const veractualizarestandar = () => {

        setModalstandar({ ...modalstandar, "view": true });

    }
    const verimportarsaldomateria = () => {

        setModalmateria({ ...modalmateria, "view": true });

    }
    const verimportarsaldocostos = () => {

        setSaldocostos({ ...saldocostos, "view": true });

    }
    const verimportarsaldoproducto = () => {

        setSaldoproducto({ ...saldoproducto, "view": true });

    }
    const verimportarsaldoproductoterminado = () => {

        setSaldoproductoterminado({ ...saldoproductotermiando, "view": true });

    }

    const updateProductionOrderStandardImp = () => {
        masive.instance.updateProductionOrderStandardImp(masive.bean.Year, _single.getAccountID())
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    setModalmasivo({ ...modalmasivo, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo Actualizar Masivamente"));
    };

    const updateProductionOrderStandardImpbyorder = () => {
        masive.instance.updateProductionOrderStandardImpbyorder(masive.bean.IDProductionOrder, masive.bean.ProductionOrderDate, _single.getAccountID())
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    setModalstandar({ ...modalstandar, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo Actualizar Estandard"));
    };
    const importRawMaterialProductionOrderInitialLefts = () => {
        masive.instance.importRawMaterialProductionOrderInitialLefts(masive.bean.Media, masive.bean.MediaContext, null)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    setModalmateria({ ...modalmateria, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo Importar Saldos Iniciales de Materia Prima a Ordenes"));
    };
    const importCostProductionOrderInitialLefts = () => {
        masive.instance.importCostProductionOrderInitialLefts(masive.bean.Media, masive.bean.MediaContext, null)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    setSaldocostos({ ...saldocostos, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo  Importar Saldos Iniciales de Costos de Producción a Ordenes"));
    };
    const importWIPProductInitialLefts = () => {
        masive.instance.importWIPProductInitialLefts(masive.bean.Media, masive.bean.MediaContext, null)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    setSaldoproducto({ ...saldoproducto, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo  Importar Saldos Iniciales de Costos de Producción a Ordenes"));
    };
    const importFinishedProductInitialLefts = () => {
        masive.instance.importFinishedProductInitialLefts(masive.bean.Media, masive.bean.MediaContext, null)
            .then((resp: any) => {
                if (resp) {
                    console.log(resp)
                    setSaldoproductoterminado({ ...saldoproductotermiando, "view": false });
                }
            })
            .catch(() => toast.error("No se pudo  Importar Saldos Iniciales de Producto Terminado a Ordenes"));
    };
    return (
        <BasicPage titulo="Tareas Especiales de Ordenes de Producción">
            <div className="row mt-4">

                <div className="col-md-3" >
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verimportarsaldomateria}>
                        Importar Saldos Iniciales de Materia Prima a Ordenes de Producción
                    </BasicButton>
                </div>
                <div className="col-md-3" >
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verimportarsaldocostos}>
                        Importar Saldos Iniciales de Costos de Producción a Ordenes de Producción
                    </BasicButton>
                </div>
                <div className="col-md-3" >
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verimportarsaldoproducto}>
                        Importar Saldos Iniciales de Producto en Proceso a Ordenes de Producción
                    </BasicButton>
                </div>
                <div className="col-md-3" >
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verimportarsaldoproductoterminado}>
                        Importar Saldos Iniciales de Producto Terminado a Ordenes de Producción
                    </BasicButton>
                </div>
                <div className="col-md-3 mt-4">
                    <BasicButton icon="ri-profile-line" clase="btn btn-outline-primary btn-border" eventClick={veractualizarmasivo}>
                        Actualizar Masivamente Estandares de Producción
                    </BasicButton>
                </div>
                <div className="col-md-3 mt-4" >
                    <BasicButton icon="ri-bar-chart-grouped-fill" clase="btn btn-outline-primary btn-border" eventClick={veractualizarestandar}>
                        Actualizar Estandard de Orden de Producción
                    </BasicButton>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={modalmasivo} updateModal={setModalmasivo} eventModal={updateProductionOrderStandardImp} onSubmitLabel="Actualizar">
                        <div className="row">
                            <div className="col-md-12">
                                <YearSelector value={masive.bean.Year} tittle="Año" onChange={(e) => { masive.setBean({ ...masive.bean, "Year": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalstandar} updateModal={setModalstandar} eventModal={updateProductionOrderStandardImpbyorder} onSubmitLabel="Actualizar Estandard de Orden">
                        <div className="row">
                            <ProductionOrderEditor IDOrderProduction={masive.bean.IDProductionOrder} returnData={(e) => { masive.setBean({ ...masive.bean, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }) }} />
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalmateria} updateModal={setModalmateria} eventModal={importRawMaterialProductionOrderInitialLefts} onSubmitLabel="Importar Saldos Iniciales de Materia Prima">
                        <div className="row">
                            <div className="col-md-6">

                                <FileInput
                                    Media={masive.bean.Media}
                                    MediaContext={masive.bean.MediaContext}
                                    directory='saldosinicialesmateria'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { masive.setBean({ ...masive.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={saldocostos} updateModal={setSaldocostos} eventModal={importCostProductionOrderInitialLefts} onSubmitLabel="Importar Saldos Iniciales de Costos de Producción a Ordenes">
                        <div className="row">
                            <div className="col-md-6">

                                <FileInput
                                    Media={masive.bean.Media}
                                    MediaContext={masive.bean.MediaContext}
                                    directory='saldosinicialesmateria'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { masive.setBean({ ...masive.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={saldoproducto} updateModal={setSaldoproducto} eventModal={importWIPProductInitialLefts} onSubmitLabel="Importar Saldos Iniciales de Producto en Proceso">
                        <div className="row">
                            <div className="col-md-6">

                                <FileInput
                                    Media={masive.bean.Media}
                                    MediaContext={masive.bean.MediaContext}
                                    directory='saldosinicialesmateria'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { masive.setBean({ ...masive.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={saldoproductotermiando} updateModal={setSaldoproductoterminado} eventModal={importFinishedProductInitialLefts} onSubmitLabel="Importar Saldos Iniciales de Producto Terminado a Ordenes">
                        <div className="row">
                            <div className="col-md-6">

                                <FileInput
                                    Media={masive.bean.Media}
                                    MediaContext={masive.bean.MediaContext}
                                    directory='saldosinicialesmateria'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { masive.setBean({ ...masive.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}